import React from "react";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import "../../../StyleSheet/Page/PlantProject/CreatePlantProject.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  CreatePlantActions,
  CreateProjectActions,
  UpdateProjectActions,
} from "../../../Redux/Slice";
import TagsInput from "react-tagsinput";
import { useParams } from "react-router-dom";

function ProjectCreatePopup(props) {
  const { show, setShow, editPayload, plantId, refresh, setEditPayload } =
    props;
  const { id } = useParams();
  const [isEmailChecked, setIsEmailChecked] = useState(false);
  console.log(editPayload, "askjjkasdjkajkdjkas");

  const [createPayload, setCreatePayload] = useState({
    plant: id,
    project: "",
    to_email: [],
    cc_email: [],
    c_name: "",
    c_number: "",
    project_common: [],
    delete_name_list: [],
    is_email_sent: false,
  });
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [extraAddedEmail, setExtraAddedEmail] = useState([]);

  const [Email, setEmail] = useState([]);

  //console.log(createPayload, "createPayload");
  const allMails = [...createPayload?.cc_email, ...extraAddedEmail];
  const allMailsto = [...createPayload?.to_email, ...Email];

  const [fieldErrors, setFieldErrors] = useState({
    plant: "",
    project: "",
    to_email: "",
    cc_email: "",
  });
  const inputFields = [
    {
      label: "Project Name",
      id: "project",
      name: "project",
      value: createPayload.project,
    },
    // {
    //   label: "To",
    //   id: "to_email",
    //   name: "to_email",
    //   value: createPayload.to_email,
    // },
  ];
  const [ProjectCommonFolder, setProjectCommonFolder] = useState([
    "ATTENDANCE",
    "INVOICE_WORKING",
    "DIG_INVOICE",
    "PF_DECLARATION",
    "ESI_DECLARATION",
    "ECR_STATEMENT",
    "GST_TAX CHALLAN",
    "PROFESSIONAL_TAX CHALLAN",
    "BANK_STATEMENT",
    "PO_AND_WO",
    "WAGE_REGISTER",
    "MATERIAL_DC",
    "OTHERS",
  ]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [uncheckedItems, setUncheckedItems] = useState([]);

  //console.log(uncheckedItems,checkedItems,"checkedItems")

  useEffect(() => {
    if (show) {
      setCheckedItems([
        "ATTENDANCE",
        "INVOICE_WORKING",
        "DIG_INVOICE",
        "PF_DECLARATION",
        "ESI_DECLARATION",
        "ECR_STATEMENT",
        "GST_TAX CHALLAN",
        "PROFESSIONAL_TAX CHALLAN",
        "BANK_STATEMENT",
        "PO_AND_WO",
        "WAGE_REGISTER",
        "MATERIAL_DC",
        "OTHERS",
      ]);
    } else {
      setCheckedItems([]);
      setUncheckedItems([]);
    }
  }, [show]);

  useEffect(() => {
    setCreatePayload({
      ...createPayload,
      project_common: checkedItems,
      delete_name_list: uncheckedItems,
    });
  }, [checkedItems, uncheckedItems]);

  const handleCheckboxChange = (event) => {
    const target = event.target;
    const itemName = target.name;
    const isChecked = target.checked;

    if (isChecked) {
      //console.log("true")
      if (!checkedItems.includes(itemName)) {
        setCheckedItems([...checkedItems, itemName]);
      }
      setUncheckedItems(uncheckedItems.filter((item) => item !== itemName));
    } else {
      //console.log("false")
      setCheckedItems(checkedItems.filter((item) => item !== itemName));
      if (!uncheckedItems.includes(itemName)) {
        setUncheckedItems([...uncheckedItems, itemName]);
      }
    }
  };

  const handleSubmit = () => {
    if (Object.entries(editPayload).length > 0) {
      const payload = {
        projectName: createPayload,
        id: editPayload.id,
      };
      dispatch(UpdateProjectActions(payload));
    } else {
      // setTimeout(() => {
      const updatedCreatePayload = { ...createPayload };

      // Remove delete_name_list key
      delete updatedCreatePayload.delete_name_list;
      //console.log(updatedCreatePayload,"updatedCreatePayload")

      dispatch(CreateProjectActions(updatedCreatePayload));
      // }, 500);
    }
    handleClose();
  };

  useEffect(() => {
    if (Object.entries(editPayload).length > 0) {
      console.log(editPayload, "createPayloadcreatePayloadcreatePayload");
      setEditMode(true);
      setCreatePayload((prevState) => ({
        ...prevState,
        project: editPayload.project,
        plant: editPayload.plant.id,
        to_email: editPayload?.project_emails[0]?.to_email,
        c_name: editPayload.c_name,
        c_number: editPayload.c_number,
        cc_email: editPayload?.project_emails[0]?.cc_email,
        is_email_sent: editPayload?.project_emails[0]?.is_email_sent,
      }));
      // setExtraAddedEmail(
      //   editPayload?.project_emails[0]?.cc_email.length
      //     ? editPayload?.project_emails[0]?.cc_email
      //     : []
      // );

      // setEmail(
      //   editPayload?.project_emails[0]?.to_email.length
      //   ? editPayload?.project_emails[0]?.to_email
      //   : []
      // )

      if (editPayload.project_common == null) {
        setCheckedItems([]);
      } else {
        setCheckedItems(editPayload.project_common);
      }
    }
  }, [editPayload]);
  useEffect(() => {
    setIsEmailChecked(editPayload?.is_email_sent || false);
  }, [editPayload]);

  const handleCheckboxChangeEmail = (e) => {
    const checked = e.target.checked; // Get the checked state of the checkbox
    setIsEmailChecked(checked); // Update the state
    console.log(checked, "Checkboxis now");
    // Log the current state
    setCreatePayload((prevState) => {
      return {
        ...prevState,
        is_email_sent: checked,
      };
    });
  };

  const handleClose = () => {
    setCreatePayload((prev) => {
      return {
        ...prev,
        plant: id,
        project: "",
        to_email: [],
        cc_email: [],
        c_name: "",
        c_number: "",
        project_common: [],
        delete_name_list: [],
        is_email_sent: false,
      };
    });
    setFieldErrors({ project: "", to_email: "", cc_email: "" });
    setEditPayload({});
    setShow(false);
  };

  const HandleChanges = (e) => {
    setFieldErrors((prev) => {
      return {
        ...prev,
        [e.target.name]: "",
      };
    });
    setCreatePayload((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      className="modelman"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {Object.entries(editPayload).length > 0
            ? "Update Project"
            : "Create Project"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {inputFields.map((field, index) => (
          <div key={index}>
            <label htmlFor={field.id} className="form-label">
              {field.label}
              <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id={field.id}
              autoComplete="off"
              name={field.name}
              value={field.value}
              onChange={(e) => {
                HandleChanges(e);
              }}
            />
            {fieldErrors[field.name] ? (
              <div
                className="error"
                style={{
                  color: "#626262",
                  height: "20px",
                  padding: "5px",
                }}
              >
                {fieldErrors[field.name]}
                <span style={{ color: "red" }}>*</span>
              </div>
            ) : (
              <div
                className="error"
                style={{
                  // color: "red",
                  height: "20px",
                  width: "100%",
                }}
              ></div>
            )}
          </div>
        ))}
        <div className="ccMailDiv mb-3">
          <label className="form-label">
            TO
            <span style={{ color: "red" }}>*</span>
          </label>
          <TagsInput
            value={
              Object.entries(editPayload).length > 0
                ? allMailsto
                : createPayload?.to_email
            }
            id="taginput"
            onChange={(tags) => {
              setCreatePayload((prev) => {
                return {
                  ...prev,
                  to_email: tags,
                };
              });
              setEmail([]);
            }}
            validationRegex={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
            addOnBlur={true}
            addOnPaste={true}
            className="react-tagsinput-language"
            name="languages_known"
            inputProps={{
              placeholder: "Add To",
            }}
          />
        </div>
        <div className="ccMailDiv">
          <label className="form-label">
            CC
            <span style={{ color: "red" }}>*</span>
          </label>
          <TagsInput
            value={
              Object.entries(editPayload).length > 0
                ? allMails
                : createPayload?.cc_email
            }
            id="taginput"
            onChange={(tags) => {
              setCreatePayload((prev) => {
                return {
                  ...prev,
                  cc_email: tags,
                };
              });
              setExtraAddedEmail([]);
              //console.log(tags);
            }}
            validationRegex={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
            addOnBlur={true}
            addOnPaste={true}
            className="react-tagsinput-language"
            name="languages_known"
            inputProps={{
              placeholder: "Add Cc",
            }}
          />
        </div>
        <div className="mt-3">
          <label className="form-label">
            Customer Name
            <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="c_name"
            value={createPayload.c_name}
            className="form-control"
            onChange={(e) => {
              HandleChanges(e);
            }}
          ></input>
        </div>
        <div className="mt-3">
          <label className="form-label">
            Customer Number
            <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="number"
            name="c_number"
            value={createPayload.c_number}
            className="form-control"
            onChange={(e) => {
              HandleChanges(e);
            }}
          ></input>
        </div>
        <div
          className="checkbox"
          style={{ display: "flex", alignItems: "center", marginTop: "5px" }}
        >
          {" "}
          <input
            type="checkbox"
            id="emailCheck"
            onChange={handleCheckboxChangeEmail}
            checked={isEmailChecked}
          />
          {console.log(isEmailChecked, "sdlkaslkdaskld")}
          <label style={{ marginTop: "10px" }} htmlFor="emailCheck">
            UDS Portal
          </label>
        </div>

        <div className="form-group mt-4">
          <div>
            <label>Project Common</label>

            <div className="row">
              <div className="col-5">
                {ProjectCommonFolder.map((ele, index) => {
                  if (index <= 6) {
                    return (
                      <div key={index} className="checkbox">
                        <input
                          type="checkbox"
                          id={ele}
                          name={ele}
                          onChange={handleCheckboxChange}
                          checked={checkedItems?.includes(ele)}
                        />
                        <label htmlFor={ele}>{ele}</label>
                      </div>
                    );
                  }
                })}
              </div>
              <div className="col-7">
                {ProjectCommonFolder.map((ele, index) => {
                  if (index > 6) {
                    return (
                      <div key={index} className="checkbox">
                        <input
                          type="checkbox"
                          id={ele}
                          name={ele}
                          onChange={handleCheckboxChange}
                          checked={checkedItems?.includes(ele)}
                        />
                        <label htmlFor={ele}>{ele}</label>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          style={{ backgroundColor: "#f26639", border: "none" }}
          // disabled={
          //   createPayload?.project?.length > 0 &&
          //   createPayload?.email_to?.length > 0
          //     ? false
          //     : true
          // }
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ProjectCreatePopup;
